import {FILTER_BAR_MODULE} from "../filter-bar-module.consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import type {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {FilterBarModuleToggleClickEvent} from "../models/filter-bar-module.toggle-click.event";

export class FilterBarModuleToggleClickHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = FILTER_BAR_MODULE.ANALYTICS.ACTION_TYPES.toggleClick;
  eventType = FilterBarModuleToggleClickEvent;
}
